import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export const LeftRequestItem = ({ item, ...rest }) => (
    <div className="request-item">
        <span className="request-container-label">Agent</span>
        <span className="request-container-value">[{item.agentId}] {item.agentName}</span>

        <span className="request-container-label">Requested Dates</span>
        
        { 
            item.startDate !== item.endDate && item.endDate ? (<span className="request-container-value">{item.startDate} - {item.endDate}</span>) : 
                                                              (<span className="request-container-value">{item.startDate}</span>)
        }

        <span className="request-container-label">Requested Hours</span>
        <span className="request-container-value">{item.totalHours} Hrs</span>
        
        { 
            item.timeoffType === 1 ? 
                                    <div> 
                                        <span className="request-container-label">PTO Balance as of {item.startDate}</span>
                                        <span className="request-container-value">{item.ptoBalance} Hrs (before request)</span>
                                        <span className="request-container-label">PTO Balance as of {item.startDate}</span>
                                        <span className="request-container-value">{item.ptoBalance - item.totalHours} Hrs (after request)</span>
                                        {(item.ptoBalance - item.totalHours) < 0 ? <span className="request-exceed-value">This Time Off request exceeds the Agent's currently accrued hours</span> : ""}
                                     </div>
                                : ""
        }

    </div>
);

export const RightRequestItem = ({ item, isModal, status, ...rest }) => (
    <div className="right-request-item">
        <span className="request-container-label">Type</span>
        {
            <span className="request-container-value">{item.timeoffValue}</span>
        }

        <span className="request-container-label">Reason</span>
        <span className="request-container-value">{item.timeoffReason}</span>

        <span className="request-container-label">Submitted</span>
        <span className="request-container-value">{item.dateCreated}</span>
        
        {isModal ? 
            <span>
                <span className="request-container-label">Status</span>
                <span className="request-container-value">{status}</span>
            </span>
        : ''
        }
    </div>
);

export class ApprovalButton extends Component {
    constructor(props){
        super(props)
        this.approveClicked = this.approveClicked.bind(this)
        this.cancelClicked = this.cancelClicked.bind(this)
    }

    approveClicked(){
        if (this.props.onClick)
            this.props.onClick(this.props.requestID); 
    }

    cancelClicked(){
        if (this.props.denyClicked)
            this.props.denyClicked(this.props.requestID); 
    }
    render(){
        let linkText = this.props.isCancel? 'Cancel' : 'Deny'
        let buttonText = this.props.currentTab === 'Approved'? 'Deny' : 'Approve'
        let isDisabled = this.props.isDisabled ? true: false
        return(
            <div className="request-button-container">
                <Link to="#" className="request-link" onClick={this.cancelClicked}>{linkText}</Link>
                <button 
                className="cf-button cf-button-blue request-button" 
                type="button" 
                onClick={this.approveClicked}
                disabled={isDisabled}>{buttonText}</button> 
            </div>
        )
    }    
};


// WEBPACK FOOTER //
// ./src/features/timeoff/TimeOff/TimeOffDetail.js